export const emptyStates = [
  { error: 'no-text', icon: 'add-text' }, // pas de texte de recherche
  { error: 'invalid-topics', icon: 'warning-circle' }, // veille obsolète
  { error: 'no-topic', icon: 'add-message' }, // pas de thème
  { error: 'no-text-or-topic', icon: 'tender-search' }, // pas de texte ni de thème
  { error: 'no-period', icon: 'no-calendar' }, // pas de période
  { error: 'no-perimeter', icon: 'close-circle-fill' }, // pas de périmètre
  { error: 'no-type', icon: 'close-circle-fill' }, // pas de type
  { error: 'watch-intro', icon: 'binocular-plus' }, // premiere veille
  { error: 'watch-no-results', icon: 'close-circle-fill' }, // veille ø résultat
  { error: 'preview-watch-no-results', icon: 'close-circle-fill' }, // veille ø résultat
  { error: 'first-day-watch-not-ready', icon: 'hourglass-up' }, // veille nouvelle avant premier lot
  { error: 'today-watch-not-ready', icon: 'hourglass-up' }, // veille existante consultée entre 00h et 06h
  { error: 'no-results', icon: 'close-circle-fill' }, // ø résultat
  { error: 'no-qualified-tenders', icon: 'close-circle-fill' }, // ø résultat en go/no-go
];
